var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"id":"connection-line"}},[_c('path',{staticClass:"chart__connection-line-path",attrs:{"id":"line","stroke":_vm.borderColor,"stroke-width":_vm.borderWidth,"d":_vm.path}})])
}
var staticRenderFns = []

export { render, staticRenderFns }